module.exports = __webpack_public_path__ + "media/images/crypto/bitcoin_small-e94d7d2b97f85f8fced5c353a4461bec.png";